/* src/app/pages/previous-analysis/previous-analysis.component.scss */
.matwidth {
  width: fit-content;
}
.mat-div {
  margin-bottom: 10px;
}
/*# sourceMappingURL=previous-analysis.component.css.map */
